<div class="d-flex justify-content-between flex-wrap" *ngIf="(propertiesQuery.selectAll$ | async | find: 'Id': spec: true) as property">
  <ng-container *ngIf="property.TypeClv !== Classificators.PropertyType.DateTime; else dateFilter">
    <app-column-filter-field-constraints-view class="col" [filter]="specFilter">
    </app-column-filter-field-constraints-view>
    <p-columnFilter #specFilter
                    [matchMode]="'equals'"
                    [matchModeOptions]="property.TypeClv === Classificators.PropertyType.Numeric ? numericMatchModeOptions : choiceMatchModeOptions"
                    [type]="property.TypeClv === Classificators.PropertyType.Numeric ? 'numeric' : 'text'"
                    display="menu"
                    [field]="'Specs.' + spec">
      <ng-template pTemplate="filter" let-value let-filter="filterCallback" let-constraint="filterConstraint">
        <ng-select *ngIf="constraint?.matchMode !== 'exists' && constraint?.matchMode !== 'notExists'" class="select-sm form-control dropdown-auto-width"
                   name="specFilter-{{spec}}"
                   [selectOnTab]="true" [addTag]="true" [appendTo]="null"
                   [items]="(allSpecs | find: 'Key' : spec)?.Value"
                   [ngModel]="value"
                   (ngModelChange)="filter($event)">
        </ng-select>
      </ng-template>
    </p-columnFilter>
  </ng-container>
  <ng-template #dateFilter>
    <app-column-filter-field-constraints-view class="col" [filter]="specFilter">
      <ng-template #valueTemplate let-value="value">
        {{value === '*' ?  value : value | date : 'shortDate'}}
      </ng-template>
    </app-column-filter-field-constraints-view>
    <p-columnFilter #specFilter
                    matchMode="dateAfter"
                    [matchModeOptions]="dateMatchModeOptions"
                    type="date"
                    display="menu"
                    [field]="'Specs.' + spec">
      <ng-template pTemplate="filter" let-value let-filter="filterCallback" let-constraint="filterConstraint">
        <input *ngIf="constraint?.matchMode !== 'exists' && constraint?.matchMode !== 'notExists'"
               id="filterByDeliveryDate" name="filterByDeliveryDate" class="form-control form-control-sm"
               ngbDatepicker #dFrom="ngbDatepicker" (click)="dFrom.toggle()" type="search" [ngModel]="value" (ngModelChange)="filter($event)">
      </ng-template>
    </p-columnFilter>
  </ng-template>
</div>
